import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/ignoreElements';
import type { Action } from '../../state/actions';
import { RELOAD_ON_REFRESH } from '../../state/entities/actions';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<Action>) =>
	action$
		.ofType(RELOAD_ON_REFRESH)
		// this .mergeMap should have been .delay but
		// useFakeTimers in jest have no effect on the timing of that operator
		// https://github.com/redux-observable/redux-observable/issues/180
		.mergeMap(() => Observable.interval(1000).take(1))
		.do(() => {
			window.location.reload();
		})
		.ignoreElements();
